import { formatNumberToContext } from './format-number-to-context.js'

export function valueFormatter (cellParams) {
  if (!cellParams.value) return

  return formatNumberToContext(cellParams.value, cellParams.context)
}
